import React from "react";
import Translate from "react-translate-component";
import TranslateWithLinks from "../../Utility/TranslateWithLinks";

const ShortObjectId = ({
  objectId
}) => {
  if (typeof objectId === "string") {
    const parts = objectId.split(".");
    const {
      length
    } = parts;
    if (length > 0) return "#" + parts[length - 1];
  }

  return objectId;
};

export const ProposalDelete = ({
  op,
  fromComponent
}) => {
  if (fromComponent === "proposed_operation") {
    return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Translate, {
      component: "span",
      content: "proposal.proposal_update"
    }));
  } else {
    return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(TranslateWithLinks, {
      string: "operation.proposal_delete",
      keys: [{
        type: "account",
        value: op[1].fee_paying_account,
        arg: "account"
      }, {
        value: /*#__PURE__*/React.createElement(ShortObjectId, {
          objectId: op[1].proposal
        }),
        arg: "proposal"
      }]
    }));
  }
};